import TargetableSlider from "components/Home/TargetableSlider";
import { fromNow } from "utils/fromNow";
type Props = {
  item?: any;
  onTouchStart?: () => void;
  onTouchEnd?: () => void;
  isMobile?: boolean;
};

const LastUpdateCard = ({
  item,
  onTouchEnd,
  onTouchStart,
  isMobile,
}: Props) => {
  return (
    <div>
      <div
        className="px-3"
        dangerouslySetInnerHTML={{ __html: item?.contents.body }}
      ></div>
      {item?.youtube_video_id && (
        <iframe
          src={"https://www.youtube.com/embed/" + item?.youtube_video_id}
          height={isMobile ? 205 : 400}
          allowFullScreen
          className="mb-3"
        ></iframe>
      )}
      <TargetableSlider
        images={item?.photos}
        title=""
        isLastUpdates
        onTouchEnd={onTouchEnd}
        id={item?.id ?? ""}
        onTouchStart={onTouchStart}
      />
      <div
        className={`d-flex align-items-center justify-content-end mx-3 ${
          item?.photos?.length > 0 ? "mt-3" : ""
        }`}
      >
        <i className="fe-clock mx-1 fs-lg" />
        <span>{fromNow(item?.created_at)}</span>
      </div>

      <div
        style={{
          borderBottom: "5px solid var(--lastupdate-border)",
        }}
        className="my-3 w-100"
      ></div>
    </div>
  );
};

export default LastUpdateCard;
